import { render, staticRenderFns } from "./card-caption.vue?vue&type=template&id=9505023c&scoped=true"
import script from "./card-caption.vue?vue&type=script&lang=js"
export * from "./card-caption.vue?vue&type=script&lang=js"
import style0 from "./card-caption.vue?vue&type=style&index=0&id=9505023c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9505023c",
  null
  
)

export default component.exports